window.dataLayer = window.dataLayer || [];
window.formStartEvent = formStartEvent;
window.formCompleteEvent = formCompleteEvent;
window.faqItemClicked = faqItemClicked;

let formStarted = false;
const pageId = document.currentScript.getAttribute('data-pageId')
const pageName = document.currentScript.getAttribute('data-pageName');
const documentType = document.currentScript.getAttribute('data-documentType');

// page load
document.addEventListener("DOMContentLoaded", () => {
    dataLayer.push({
        "event": "page_load",
        "data": {
            "language": `${document.documentElement.lang}`,
            "page": `${pageId}`,
            "page_name": `${pageName}`,
            "page_type": `${documentType}`
        }
    });
});

function formStartEvent(formStartEventOptions) {
    if(formStarted === true){
        return;
    }

    dataLayer.push({
        "event": `form_${formStartEventOptions.formName}_start`,
        "data": {
            "level_1": "form",
            "level_2": "form_start",
            "level_3": `${formStartEventOptions.formName}`,
            "level_4": `${formStartEventOptions.stepNumber}`
        }
    });

    formStarted = true
}

// when completing the form/funnel:
function formCompleteEvent(formCompleteEventOptions) {
    const eventData = {
        "level_1": "form",
        "level_2": "complete",
        "level_3": formCompleteEventOptions.formName,
        "level_4": formCompleteEventOptions.stepNumber,
    }

    formCompleteEventOptions.selectedValues.forEach((selectedValue) => {
        eventData[`level_${Object.keys(eventData).length + 1}`] = selectedValue.value
    })

    const enhancedConversionsData = {
        "email": formCompleteEventOptions.enhancedConversions.email,
        "phone_number": formCompleteEventOptions.enhancedConversions.phoneNumber,
        "address": {
            "first_name" : formCompleteEventOptions.enhancedConversions.firstName
        }
    }


    dataLayer.push({
        "event": `form_${formCompleteEventOptions.formName}_complete`,
        "data": { ...eventData, ...enhancedConversionsData }
    });
}

function faqItemClicked(title) {
    dataLayer.push({
        "event": "faq_item_click",
        "data": {
            "level_1": "faq",
            "level_2": "result_click",
            "level_3": `${pageName}`,
            "level_4": `${title}`,
        }
    })
}
